import { InjectionToken } from '@angular/core';

import { TranslationAdapter } from './translation-adapter.interface';

export const TRANSLATION_ADAPTER = new InjectionToken<TranslationAdapter>('Translation Adapter');
